<template>
    <!-- :style="{minHeight: bodyHeight}" -->
    <Layout>

        <Layout>
            <!-- <Sider hide-trigger collapsible :collapsed-width="78" style="width: 255px;min-width: 255px;">
        <div class="side-logo">
          <img v-if="true" src="@assets/img/exhibition/logo-1.png" style="display: inline-block;" @click="$router.push('/exhibition/index/home')" class="f-csp" />
          <img src="@assets/img/exhibition/logo.png" alt="云展台" title="云展台" @click="$router.push('/exhibition/index/home')" class="f-csp" v-else />
        </div>
        <gSide :siderArr="siderArr"></gSide>
      </Sider> -->
            <Header :style="{ padding: 0 }" class="layout-header-bar">
                <gHead></gHead>
            </Header>
            <div style="width: 100%;background-color: #fff;">
                <Layout style="height: 100%;width:calc(100% - 255px);margin: 0 auto;background-color: #fff;" :style="{ minHeight: bodyHeight }">

                    <Content>
                        <div :style="{ minHeight: '500px' }">
                            <router-view />
                        </div>
                    </Content>
                    <Footer>
                        <copyright />
                    </Footer>
                </Layout>
            </div>


        </Layout>
        <Contact />
    </Layout>
</template>

<script>
import gHead from "@components/gHead/gHead1";
import gSide from "@components/gSide/gSide";
import copyright from "@components/copyright/copyright";
import Contact from "@components/Contact/Contact";
import gSwiper from "@components/gSwiper/gSwiper.vue";
import { mapGetters } from "vuex";
export default {
    name: "exhibition-layout",
    data () {
        return {
            bodyHeight: "800px",
            siderArr: [
                {
                    title: "首页",
                    icon: "icon-shouye11",
                    router: "/exhibition/index/home",
                    type: 1,
                },

                {
                    title: "填报表单",
                    icon: "icon-fuwu1",
                    type: 2,
                    children: [
                        {
                            title: "会刊免费登记表",
                            router: "/exhibition/index/exinfo/catalogue"
                        },
                        {
                            title: "参展展品信息申报表",
                            router: "/exhibition/index/exinfo/catalogue2"
                        },
                        {
                            title: "展位楣板信息登记表",
                            router: "/exhibition/index/exinfo/catalogue3"
                        },
                        {
                            title: "参展商胸卡信息登记表",
                            router: "/exhibition/index/exinfo/catalogue4"
                        },
                        {
                            title: "会刊广告征订表",
                            router: "/exhibition/index/exinfo/catalogue5"
                        },
                        {
                            title: "现场广告征订表",
                            router: "/exhibition/index/exinfo/catalogue6"
                        },
                        {
                            title: "标准展台搭建变更申请表",
                            router: "/exhibition/index/exinfo/catalogue7"
                        },
                        {
                            title: "增租家具及电信服务一览表",
                            router: "/exhibition/index/exinfo/catalogue8"
                        },
                        {
                            title: "展台现场拆除&安装施工价目表",
                            router: "/exhibition/index/exinfo/catalogue9"
                        },
                    ]
                },


            ]
        };
    },
    components: {
        gHead,
        gSide,
        Contact,
        copyright,
        gSwiper
    },
    computed: {
        ...mapGetters({
            exhibition: "loginModule/getExhibition"
        }),
    },
    created () {
        this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";

    },
};
</script>

<style lang="scss">
body {
    padding-right: 0 !important;
}
</style>
<style scoped lang='scss'>
.layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.side-logo {
    text-align: center;
    height: 64px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        max-width: 98%;
        max-height: 98%;
    }
}

.layoutcalss {

    background-color: #fff;

}
</style>
